import Service from "../Service";

const resource = "hmnAgreement/";

export default {
  sign(payload, requestID) {
    return Service.post(resource + "sign", payload, {
      params: { requestID },
    });
  },

  getPendingSign(wkrID, requestID) {
    return Service.get(resource + "pendingSign", {
      params: { wkrID, requestID },
    });
  },

  getPendingSignByDocument(prsDocumentNumber, requestID) {
    return Service.get(resource + "pendingSignByDocument", {
      params: { prsDocumentNumber, requestID },
    });
  },

  getContractById(agtID, requestID, isWorkerView = false) {
    return Service.post(resource + "searchContract", {}, {
      params: { AgtID: agtID, requestID, isWorkerView },
    });
  },

  enqueueTurn(payload, requestID) {
    return Service.post(resource + "enqueueTurn", payload, {
      params: { requestID },
    });
  },

  saveAuditLog(payload, requestID) {
    return Service.post(resource + "auditLog", payload, {
      params: { requestID },
    });
  },

  getQueueState(requestID) {
    return Service.get(resource + "queueState", {
      params: { requestID },
    });
  },

  registerKiosk(kioskId, requestID, forceTakeover = false) {
    return Service.post(resource + "registerKiosk", {}, {
      params: { kioskId, requestID, forceTakeover },
    });
  },

  releaseKiosk(kioskId, requestID) {
    return Service.post(resource + "releaseKiosk", {}, {
      params: { kioskId, requestID },
    });
  },

  completeKioskDocuments(kioskId, turnId, auditPayload = null) {
    return Service.post(resource + "completeDocuments", auditPayload || {}, {
      params: { kioskId, turnId },
    });
  },

  cancelTurn(turnId, requestID) {
    return Service.post(resource + "cancelTurn", {}, {
      params: { turnId, requestID },
    });
  },

  finishSignedContract(payload, requestID) {
    return Service.post(resource + "finishSignedContract", payload, {
      params: { requestID },
    });
  },

  generateDniCopy(payload, requestID) {
    return Service.post(resource + "generateDniCopy", payload, {
      params: { requestID },
    });
  },

  resetQueue(requestID) {
    return Service.post(resource + "resetQueue", {}, {
      params: { requestID },
    });
  },

  updateSalary(payload, requestID) {
    return Service.post(resource + "updateSalary", payload, {
      params: { requestID },
    });
  },

  authorizeSalaryField(payload, requestID) {
    return Service.post(resource + "authorizeSalaryField", payload, {
      params: { requestID },
    });
  },

  salaryHierarchyAccess(payload, requestID) {
    return Service.post(resource + "salaryHierarchyAccess", payload, {
      params: { requestID },
    });
  },

  getContractPreviewHtml(payload, requestID) {
    return Service.post(resource + "previewHtml", payload, {
      params: { requestID },
    });
  },

  runValidationQueueJob(requestID) {
    return Service.post(resource + "runValidationQueueJob", {}, {
      params: { requestID },
    });
  },

  getValidationQueueStatus(requestID) {
    return Service.get(resource + "getContractQueueValidationStatus", {
      params: { requestID },
    });
  },

  getWorkerFiles(dni, campaignName, positionName, requestID) {
    return Service.get(resource + "workerFiles", {
      params: { dni, campaignName, positionName, requestID },
    });
  },

  uploadWorkerFile(formData, requestID) {
    return Service.post(resource + "uploadWorkerFile", formData, {
      params: { requestID },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  deleteWorkerFile(payload, requestID) {
    return Service.post(resource + "deleteWorkerFile", payload, {
      params: { requestID },
    });
  },

  getDownloadWorkerFileUrl(dni, fileName, campaignName, positionName, inline = false) {
    const base = Service.defaults.baseURL || "";
    const cleanBase = base.endsWith("/") ? base.slice(0, -1) : base;
    const q = new URLSearchParams({
      dni: dni || "",
      fileName: fileName || "",
      campaignName: campaignName || "",
      positionName: positionName || "",
      inline: inline ? "true" : "false",
    });
    return `${cleanBase}/${resource}downloadWorkerFile?${q.toString()}`;
  },

  getTurnDisplayVideos(paramName = null) {
    return Service.get(resource + "turnDisplayVideos", {
      params: { paramName },
    });
  },

  getStreamTurnVideoUrl(fileName, paramName = null) {
    const base = Service.defaults.baseURL || "";
    const cleanBase = base.endsWith("/") ? base.slice(0, -1) : base;
    const q = new URLSearchParams({
      fileName: fileName || "",
    });
    if (paramName) q.append("paramName", paramName);
    return `${cleanBase}/${resource}streamTurnVideo?${q.toString()}`;
  },

  assignMedicalEvaluation(payload, requestID) {
    return Service.post(resource + "assignMedicalEvaluation", payload, {
      params: { requestID },
    });
  },

  getWorkerMedicalEvaluations(dni, agtID, requestID) {
    return Service.get(resource + "workerMedicalEvaluations", {
      params: { dni, agtID, requestID },
    });
  },

  resendSignedDocumentsEmail(payload, requestID) {
    return Service.post(resource + "resendSignedDocumentsEmail", payload, {
      params: { requestID },
    });
  },
};

